<template>
  <FeaturedCollection
    v-if="collectionLoaded"
    :url="'/collection/' + currentCollection.id"
    :title="currentCollection.name"
    :items="items"
    :description="currentCollection.description"
    :background-image-url="currentCollection.banner"
    :index="index"
  />
</template>

<script>
import Vue from 'vue'
import { mapGetters, mapActions } from 'vuex'
import FeaturedCollection from './FeaturedCollection'

export default Vue.extend({
  name: 'FeaturedCollectionHost',
  components: {
    FeaturedCollection
  },
  props: {
    configurations: {
      type: Object,
      default: () => {}
    },
    index:{
      type: Number,
      default:0
    }
  },
  computed: {
    ...mapGetters({
      collection: 'productCatalog/collection'
    }),
    collectionLoaded () {
      return (
        this.currentCollection !== null &&
        this.currentCollection.products.length > 0
      )
    },
    currentCollection () {
      return this.collection(this.configurations.id)
    },
    items () {
      return this.currentCollection.products.map(value => {
        return {
          title: value.name,
          imageUrl: value.icon,
          targetUrl: '/product/' + value.id,
          genre: value.genres
            .map(g => {
              return g.name
            })
            .join(', '),
            id: value.id,
        }
      })
    }
  },
  created () {
    if (this.currentCollection === null) {
      this.loadCollection(this.configurations.id)
    } else if (this.currentCollection.products.length === 0) {
      this.loadCollectionProducts(this.configurations.id)
    }
  },
  methods: {
    ...mapActions({
      loadCollection: 'productCatalog/loadCollection',
      loadCollectionProducts: 'productCatalog/loadCollectionProducts'
    })
  }
})
</script>
